import { useState, useEffect } from 'react';

export default function useClusterOwner(form, formType) {
    const [selectedOwner, setSelectedOwner] = useState('');

    useEffect(() => {
        if (formType === 'edit' && form?.user?.length > 0) {
            setSelectedOwner(form.user[0]);
        }
    }, [formType, form]);

    return { selectedOwner, setSelectedOwner };
}
